import { Autocomplete, AutocompleteProps, TextField } from '@mui/material';
import React, { ReactElement } from 'react';

export interface SGAutocompleteProps<
  Value,
  Multiple extends boolean | undefined = false,
  DisableClearable extends boolean | undefined = false,
  FreeSolo extends boolean | undefined = false,
> extends Omit<
    AutocompleteProps<Value, Multiple, DisableClearable, FreeSolo>,
    'renderInput' | 'color'
  > {
  color?: 'primary' | 'secondary' | 'error' | 'info' | 'success' | 'warning';
  margin?: 'dense' | 'normal' | 'none';
  hasError?: boolean;
  error?: string;
  name?: string;
  label?: string;
  shrink?: boolean;
  required?: boolean;
}

export function SGAutocomplete<
  Value,
  Multiple extends boolean | undefined = false,
  DisableClearable extends boolean | undefined = false,
  FreeSolo extends boolean | undefined = false,
>({
  error,
  hasError,
  color = 'primary',
  margin,
  name,
  label,
  shrink,
  required,
  ...props
}: SGAutocompleteProps<
  Value,
  Multiple,
  DisableClearable,
  FreeSolo
>): ReactElement {
  return (
    <Autocomplete<Value, Multiple, DisableClearable, FreeSolo>
      {...props}
      renderInput={(params) => (
        <TextField
          size={props.size}
          {...params}
          color={color}
          name={name}
          label={label}
          placeholder={props.placeholder}
          margin={margin || (props.size === 'small' ? 'none' : 'normal')}
          variant="outlined"
          required={required}
          disabled={props.disabled}
          error={hasError !== undefined ? hasError : !!error}
          helperText={error}
          InputLabelProps={{
            shrink: shrink,
          }}
        />
      )}
    />
  );
}
